/* Spill Safe Storage — collection page: spec chips, short card titles, range tiles, bund finder, filters (+ active tags, URL state),
   sort, show more, compare, add to basket, accessible mobile drawer (28-9-2026, refined 29-9-2026). */
(function () {
  'use strict';
  /* ---- spec parser: title + handle + description text ("|"-separated lines) -> facts ---- */
  var NUM = { one: 1, single: 1, two: 2, double: 2, twin: 2, three: 3, four: 4, five: 5, six: 6, eight: 8 };
  function num(s) { return parseFloat(String(s).replace(/,/g, '')); }
  function line(d, re) { var m = d.match(re); return m ? m : null; }
  function parseSpec(p) {
    var t = p.t || '', h = p.h || '', d = '|' + (p.d || '').replace(/\s+/g, ' ') + '|';
    var o = {};
    /* labelled size line from the product's own specification, e.g. "Size: L915 x W457 x H1829mm" or "298mmØ x H445mm" */
    var sl = line(d, /\|\s*(?:external size|external dimensions|overall size|unit size|size)\s*:\s*([^|]{3,80})/i);
    if (sl) {
      var raw = sl[1], parts = [], re = /(?:\b([LWHD])\s*)?(\d{2,4}(?:\.\d)?)\s*(mm)?\s*(Ø)?/gi, m2;
      while ((m2 = re.exec(raw)) !== null) {
        if (!m2[2]) continue;
        parts.push({ k: m2[4] ? 'Ø' : (m2[1] ? m2[1].toUpperCase() : ''), v: num(m2[2]) });
        if (parts.length >= 3) break;
      }
      if (parts.length >= 2 && /mm/i.test(raw)) {
        var labelled = parts.every(function (x) { return x.k; });
        o.dims = parts.map(function (x) { return (x.k ? x.k + ' ' : '') + x.v.toLocaleString('en-GB'); }).join(' × ') + ' mm';
        o.dimsLabelled = labelled;
        parts.forEach(function (x) { if (x.k === 'H') o.H = x.v; if (x.k === 'L') o.L = x.v; if (x.k === 'W') o.W = x.v; });
      }
    }
    /* dimensions from the title (order not stated) — only used when there is no size line */
    var dm = t.match(/(\d{2,4})\s*(?:mm)?\s*[x×]\s*(\d{2,4})\s*(?:mm)?(?:\s*[x×]\s*H?\s*(\d{2,4}))?\s*mm/i);
    if (dm) o.dim = [dm[1], dm[2], dm[3]].filter(Boolean).join(' × ') + ' mm';
    var dia = t.match(/(\d{2,4})\s*mm\s*Ø(?:\s*x\s*H?\s*(\d{2,4})\s*mm)?/i);
    if (dia && !dm) o.dim = dia[1] + ' Ø' + (dia[2] ? ' × ' + dia[2] : '') + ' mm';
    /* sump capacity: an explicit spec line, else the handle */
    var sm = line(d, /\|\s*(?:sump|bund|bunded|containment|spill)\s*capacity\s*:?\s*(?:approx\.?\s*)?([\d.,]+)\s*(?:ltr|litres?|l\b)/i) ||
             h.match(/(\d+)ltr-sump-capacity/) || h.match(/with-(\d+)ltr-sump/);
    if (sm) o.s = num(sm[1]);
    var contain = /spill pallet|spill floor|bund floor|sump floor|drip tray|can tray|drum tray|dispensing tray|dispensing system|racking sump|pallet converter|floor tray|drum trolley|poly trolley|sump floor|overpack/i.test(t);
    if (o.s == null && contain) {
      var cm = line(d, /\|\s*capacity\s*:\s*([\d.,]+)\s*(?:ltr|litres?|l\b)/i);
      if (cm) o.s = num(cm[1]);
    }
    var tl = t.match(/([\d.]+)\s*Litre/i), tln = tl ? num(tl[1]) : null;
    if (contain && tln && [200, 205, 210, 220, 1000].indexOf(tln) < 0 && (o.s == null || (/\bkit\b/i.test(t) && tln > o.s))) o.s = tln;
    /* storage / container capacity: only from an explicit "Capacity:" spec line (never from the title, which can be a sump figure) */
    if (!contain) {
      var cc = line(d, /\|\s*(?:storage |shelf )?capacity\s*:\s*([\d.,]+)\s*(?:ltr|litres?|l\b)/i);
      if (cc) o.cap = num(cc[1]);
    }
    /* doors, shelves and product weight — from their own spec lines only */
    var dr = line(d, /\|\s*number of doors\s*:\s*(\d+)/i); if (dr) o.doors = parseInt(dr[1], 10);
    var sh = line(d, /\|\s*number of shelves\s*:\s*(\d+)/i); if (sh) o.shelves = parseInt(sh[1], 10);
    var wt = line(d, /\|\s*(?:tare weight|unit weight|product weight|weight)\s*:\s*(?:approx\.?\s*)?([\d.,]+)\s*kg/i); if (wt) o.kg = num(wt[1]);
    /* what a bund holds */
    var th = t + ' ' + h;
    var hk = /\bibc/i.test(th) ? 'ibc' : (/drum/i.test(th) ? 'drum' : null);
    if (/25 ?(?:litre|ltr|l) cans?/i.test(t)) hk = 'can';
    if (contain && hk && hk !== 'can') {
      var hm = line(d, /\|\s*number of (?:containers|drums|ibcs?)\s*:\s*(\d+)\s*x/i) ||
               h.match(/(?:for|to-hold|hold-up-to)-(\d+)-(?:x-1000ltr-)?(?:drums?|ibcs?)/) ||
               h.match(/(?:^|-)(\d)-drum/) ||
               d.match(/(?:accommodates|holds?|hold up to|storing up to|store up to|for storing|designed to hold|suitable for)\s*(?:up to\s*)?(\d+|one|two|three|four|six|eight)\s*(?:x\s*)?(?:205|210|200|1,?000)\s*(?:ltr|litres?|l)?\s*(?:drums?|ibcs?)/i) ||
               t.match(/\b(single|double|\d)\s*(?:-|\s)?(?:drum|ibc)\b/i);
      if (hm) { var v = hm[1].toLowerCase(); o.hn = NUM[v] || parseInt(v, 10); o.hk = hk; }
      else if (hk === 'ibc' && /ibc spill pallet/i.test(t)) { o.hn = 1; o.hk = 'ibc'; }
    }
    if (hk === 'can' && o.s) { o.hk = 'can'; o.hn = 4; }
    var lm = t.match(/([\d.,]+)\s*kg/i);
    if (lm && o.s == null && o.cap == null && /ramp|dolly|carriage|cradle|stacker|grid|floor tray|trolley|lifter|clamp|fork/i.test(t)) o.load = num(lm[1]);
    if (o.s == null && /spill kit|refill|absorbent|\bpads\b|socks?\b|booms?\b|pillows?\b/i.test(t) && tln) o.ab = tln;
    /* material */
    var mt = line(d, /\|\s*material\s*:\s*([^|]{2,60})/i);
    if (!mt) {
      var ls = d.split('|');
      for (var i = 0; i < ls.length && !mt; i++) {
        if (/strainer|grid|\blid\b|handle|castor|wheel|lock|hinge|shel(f|ves)|mesh|door|bolt|fixing/i.test(ls[i])) continue;
        mt = ls[i].match(/(?:made|manufactured|constructed|moulded|produced|fabricated)\s+(?:from|in|of|using)\s+([^.]{3,60})/i);
      }
    }
    var ms = (mt ? mt[1] : '') + ' ' + t;
    if (/galvani[sz]ed/i.test(ms)) o.m = 'Galvanised steel';
    else if (/stainless/i.test(ms)) o.m = 'Stainless steel';
    else if (/polyethylene|polypropylene|plastic|\bpoly\b|\bMDPE\b|\bHDPE\b|\bPE\b|\bPP\b/i.test(ms)) o.m = 'Plastic';
    else if (/\bsteel\b/i.test(ms)) o.m = 'Steel';
    var cl = line(d, /\|\s*colou?r\s*:\s*([^|]{2,40})/i);
    if (cl) o.c = cl[1].trim();
    return o;
  }

  /* ---- card display title: the catalogue title minus facts shown as labelled details, and minus generic "for … storage" endings ---- */
  var GENERIC_FOR = /\s+for\s+(?:safe\s+|industrial\s+|general\s+)?(?:chemical\s+|liquid\s+|flammable\s+liquids?\s+|flammable\s+|hazardous\s+(?:liquid\s+)?|laboratory\s+|drum\s+|safe\s+liquid\s+)?(?:storage|containment|spill containment)(?:\s+of\s+hazardous\s+materials)?\s*$|\s+for\s+flammable\s+liquids?\s*$|\s+for\s+safe\s+liquid\s+dispensing\s*$|\s+for\s+safe\s+storage(?:\s+of\s+hazardous\s+materials)?\s*$/i;
  function shortTitle(it) {
    if (it.d.ct) return it.d.ct;
    var t = it.t, o = it.o;
    if (o.dims) t = t.replace(/\s*L?\s*\d{2,4}(?:\.\d)?\s*(?:mm)?\s*Ø?\s*(?:[x×]\s*[LWHD]?\s*\d{2,4}(?:\.\d)?\s*(?:mm)?\s*Ø?\s*){1,2}(?:mm)?/i, ' ');
    if (o.kg != null) t = t.replace(new RegExp('\\s*' + String(o.kg).replace('.', '\\.') + '\\s*kg\\b', 'i'), ' ');
    var lit = t.match(/\s*([\d.]+)\s*Litre\b/i);
    if (lit && ((o.s != null && num(lit[1]) === o.s) || (o.cap != null && num(lit[1]) === o.cap))) t = t.replace(lit[0], ' ');
    t = t.replace(GENERIC_FOR, '').replace(/\s{2,}/g, ' ').trim();
    return t.split(' ').length >= 2 ? t : it.t;
  }

  /* ---------- page ---------- */
  var root = document.querySelector('[data-ssc]');
  if (!root) return;
  var grid = root.querySelector('[data-ssc-grid]');
  var dataEl = root.querySelector('[data-ssc-data]');
  if (!grid || !dataEl) return;
  var data = [];
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var cards = Array.prototype.slice.call(grid.children);
  var PAGE = parseInt(root.getAttribute('data-page-size'), 10) || 12;
  var UNITS = { drum: ['drum', 'drums'], ibc: ['IBC', 'IBCs'], can: ['× 25 L can', '× 25 L cans'] };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function L(n) { return (Math.round(n * 10) / 10).toLocaleString('en-GB', { maximumFractionDigits: 1 }) + ' L'; }
  function unit(k, n) { return n + ' ' + (n === 1 ? UNITS[k][0] : UNITS[k][1]); }
  function words(s) { return String(s || '').toLowerCase().split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  function money(c) { return '£' + (c / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

  var ranges = Array.prototype.map.call(root.querySelectorAll('[data-ssc-range]'), function (b) {
    return { id: b.getAttribute('data-ssc-range'), btn: b, match: words(b.getAttribute('data-match')), ex: words(b.getAttribute('data-exclude')), badge: b.getAttribute('data-badge'), label: b.querySelector('.ssc-tile__t').textContent.trim() };
  });

  var items = data.map(function (d, i) {
    var o = parseSpec(d), tl = (d.t || '').toLowerCase(), r = null;
    for (var k = 0; k < ranges.length && !r; k++) {
      var R = ranges[k];
      if (R.match.some(function (w) { return tl.indexOf(w) > -1; }) && !R.ex.some(function (w) { return tl.indexOf(w) > -1; })) r = R;
    }
    return { i: i, el: cards[i], d: d, o: o, p: d.p, t: d.t, r: r };
  });

  /* ---------- enrich cards ---------- */
  function detailChips(it) {
    var o = it.o, ch = [];
    if (o.s != null) ch.push('Sump ' + L(o.s));
    if (o.cap != null) ch.push('Capacity ' + L(o.cap));
    if (o.dims) ch.push(o.dims);
    else if (o.dim) ch.push('Size ' + o.dim);
    if (o.hn && o.hk) ch.push('Holds ' + unit(o.hk, o.hn));
    if (o.doors) ch.push(o.doors + (o.doors === 1 ? ' door' : ' doors') + (o.shelves != null ? ' · ' + o.shelves + (o.shelves === 1 ? ' shelf' : ' shelves') : ''));
    if (o.load != null) ch.push('Load ' + o.load.toLocaleString('en-GB') + ' kg');
    if (o.ab != null) ch.push('Absorbs ' + L(o.ab));
    if (o.kg != null) ch.push('Weight ' + o.kg.toLocaleString('en-GB') + ' kg');
    return ch.slice(0, 3);
  }
  items.forEach(function (it) {
    var el = it.el, o = it.o;
    if (!el) return;
    it.short = shortTitle(it);
    var ta = el.querySelector('[data-ssc-title]');
    if (ta && it.short !== it.t) ta.textContent = it.short;
    Array.prototype.forEach.call(el.querySelectorAll('[data-ssc-name]'), function (s) { s.textContent = it.short; });
    var b = el.querySelector('[data-badge]');
    if (b && it.r) { b.textContent = it.r.badge; b.hidden = false; }
    var sub = [];
    if (o.m) sub.push(o.m);
    if (it.d.oc > 1) sub.push(it.d.oc + ' colours');
    else if (o.c) sub.push(o.c.charAt(0).toUpperCase() + o.c.slice(1));
    if (it.d.sku) sub.push('Code ' + it.d.sku);
    var se = el.querySelector('[data-sub]');
    if (se) { if (sub.length) se.textContent = sub.join(' · '); else se.remove(); }
    var ch = detailChips(it);
    var ce = el.querySelector('[data-chips]');
    if (ce) {
      if (ch.length) ce.innerHTML = ch.map(function (c) { return '<li' + (/^[LWHØ] /.test(c) ? ' title="' + (it.o.dimsLabelled ? 'L = length, W = width, H = height, as listed on the product page' : '') + '"' : '') + '>' + esc(c) + '</li>'; }).join('');
      else ce.remove();
    }
  });

  /* ---------- state ---------- */
  function emptyF() { return { m: [], s: [], a: [], h: [], dr: [], p: [] }; }
  var st = { range: null, kind: null, n: 0, f: emptyF(), sort: 'featured', shown: PAGE };
  var FACETS = [
    { k: 'm', label: 'Material', has: function (it) { return !!it.o.m; }, opts: function () {
        var seen = {}; items.forEach(function (it) { if (it.o.m) seen[it.o.m] = 1; });
        return ['Plastic', 'Galvanised steel', 'Steel', 'Stainless steel'].filter(function (m) { return seen[m]; }).map(function (m) { return { v: m, l: m, t: function (it) { return it.o.m === m; } }; });
      } },
    { k: 'h', label: 'External height', has: function (it) { return it.o.H != null; }, opts: function () {
        return [
          { v: 'a', l: 'Up to 500 mm', t: function (it) { return it.o.H != null && it.o.H <= 500; } },
          { v: 'b', l: '501 – 1,000 mm', t: function (it) { return it.o.H > 500 && it.o.H <= 1000; } },
          { v: 'c', l: '1,001 – 1,500 mm', t: function (it) { return it.o.H > 1000 && it.o.H <= 1500; } },
          { v: 'd', l: 'Over 1,500 mm', t: function (it) { return it.o.H > 1500; } }
        ];
      } },
    { k: 'dr', label: 'Doors', has: function (it) { return it.o.doors != null; }, opts: function () {
        return [
          { v: '1', l: '1 door', t: function (it) { return it.o.doors === 1; } },
          { v: '2', l: '2 doors', t: function (it) { return it.o.doors === 2; } }
        ];
      } },
    { k: 's', label: 'Sump capacity', has: function (it) { return it.o.s != null; }, opts: function () {
        return [
          { v: 'a', l: 'Up to 100 L', t: function (it) { return it.o.s != null && it.o.s <= 100; } },
          { v: 'b', l: '101 – 500 L', t: function (it) { return it.o.s > 100 && it.o.s <= 500; } },
          { v: 'c', l: 'Over 500 L', t: function (it) { return it.o.s > 500; } }
        ];
      } },
    { k: 'a', label: 'Absorbency', has: function (it) { return it.o.ab != null; }, opts: function () {
        return [
          { v: 'a', l: 'Up to 50 L', t: function (it) { return it.o.ab != null && it.o.ab <= 50; } },
          { v: 'b', l: '51 – 150 L', t: function (it) { return it.o.ab > 50 && it.o.ab <= 150; } },
          { v: 'c', l: 'Over 150 L', t: function (it) { return it.o.ab > 150; } }
        ];
      } },
    { k: 'p', label: 'Price (incl. VAT)', has: function () { return true; }, opts: function () {
        return [
          { v: 'a', l: 'Under £500', t: function (it) { return it.p < 50000; } },
          { v: 'b', l: '£500 – £1,500', t: function (it) { return it.p >= 50000 && it.p <= 150000; } },
          { v: 'c', l: 'Over £1,500', t: function (it) { return it.p > 150000; } }
        ];
      } }
  ];
  FACETS.forEach(function (F) {
    F.list = F.opts().filter(function (op) { return items.some(op.t); });
    F.cov = items.filter(F.has).length;
  });
  FACETS = FACETS.filter(function (F) { return F.list.length > 1 && F.cov >= Math.min(8, items.length); });
  function facetByK(k) { return FACETS.filter(function (F) { return F.k === k; })[0]; }

  /* sort: capacity sorting only where most products list a sump figure */
  var sortSel = root.querySelector('[data-ssc-sort]');
  var sumpCov = items.filter(function (it) { return it.o.s != null; }).length;
  if (sortSel && sumpCov < items.length * 0.5) {
    var so = sortSel.querySelector('option[value="sump-desc"]'); if (so) so.remove();
  }

  /* ---------- finder ---------- */
  var finder = root.querySelector('[data-ssc-finder]');
  var COUNTS = { drum: [1, 2, 3, 4, 6, 8], ibc: [1, 2, 3, 4], can: [2, 4, 6, 8] };
  var DEF = { drum: 4, ibc: 1, can: 4 };
  var QLABEL = { drum: 'How many drums on one bund?', ibc: 'How many IBCs on one bund?', can: 'How many 25 L cans on one tray?' };
  var KLABEL = { drum: '205 L drums', ibc: '1,000 L IBCs', can: '25 L cans', handling: 'Dispensing & handling' };
  var trayRange = null;
  ranges.forEach(function (R) { if (!trayRange && /tray/i.test(R.label)) trayRange = R; });
  function req() {
    if (!st.kind || !st.n) return 0;
    var each = st.kind === 'drum' ? 205 : st.kind === 'ibc' ? 1000 : 25;
    return Math.max(each * 1.1, each * st.n * 0.25);
  }
  function passes(it) {
    var o = it.o, need = req();
    if (st.kind === 'can') return o.s != null && o.s >= need && ((o.hk === 'can' && o.hn >= st.n) || (!o.hk && trayRange && it.r === trayRange));
    return o.hk === st.kind && o.hn >= st.n && o.s != null && o.s >= need;
  }

  /* ---------- filtering ---------- */
  function base() {
    return items.filter(function (it) {
      if (st.range && it.r !== st.range) return false;
      if (st.kind && st.kind !== 'handling' && !passes(it)) return false;
      return true;
    });
  }
  function facetOk(it, skip) {
    return FACETS.every(function (F) {
      if (F.k === skip) return true;
      var sel = st.f[F.k];
      if (!sel || !sel.length) return true;
      return F.list.some(function (op) { return sel.indexOf(op.v) > -1 && op.t(it); });
    });
  }
  function sorter(a, b) {
    switch (st.sort) {
      case 'price-asc': return a.p - b.p || a.i - b.i;
      case 'price-desc': return b.p - a.p || a.i - b.i;
      case 'sump-desc': return (b.o.s != null ? b.o.s : -1) - (a.o.s != null ? a.o.s : -1) || a.i - b.i;
      case 'title': return (a.short || a.t).localeCompare(b.short || b.t) || a.t.localeCompare(b.t);
      default:
        if (st.kind && st.kind !== 'handling') return (a.o.hn || 99) - (b.o.hn || 99) || (a.o.s || 0) - (b.o.s || 0) || a.p - b.p;
        return a.i - b.i;
    }
  }

  var fBox = root.querySelector('[data-ssc-filters]');
  function drawFilters() {
    if (!fBox) return;
    fBox.innerHTML = FACETS.map(function (F) {
      var note = F.k !== 'p' && F.cov < items.length ? '<p class="ssc-fg__note">Listed for ' + F.cov + ' of ' + items.length + ' products — products without this detail are left out while it is selected.</p>' : '';
      return '<fieldset class="ssc-fg"><legend>' + esc(F.label) + '</legend>' + F.list.map(function (op) {
        var id = 'ssc-f-' + F.k + String(op.v).replace(/\W/g, '');
        return '<label class="ssc-fo" for="' + id + '"><input type="checkbox" id="' + id + '" data-f="' + F.k + '" value="' + esc(op.v) + '"><span>' + esc(op.l) + '</span><span class="ssc-fo__n" data-fn></span></label>';
      }).join('') + note + '</fieldset>';
    }).join('');
  }
  drawFilters();

  var showing = root.querySelector('[data-ssc-showing]');
  var more = root.querySelector('[data-ssc-more]');
  var moreBtn = root.querySelector('[data-ssc-more-btn]');
  var prog = root.querySelector('[data-ssc-prog]');
  var empty = root.querySelector('[data-ssc-empty]');
  var fcount = root.querySelector('[data-ssc-fcount]');
  var reset = root.querySelector('[data-ssc-reset]');
  var active = root.querySelector('[data-ssc-active]');
  var doneBtn = root.querySelector('[data-ssc-done]');
  var typesSel = root.querySelector('[data-ssc-types-sel]');

  function activeList() {
    var a = [];
    if (st.range) a.push({ l: st.range.label, rm: function () { st.range = null; if (st.kind === 'handling') st.kind = null; } });
    if (st.kind && st.kind !== 'handling') a.push({ l: 'Bund for ' + unit(st.kind, st.n), rm: function () { st.kind = null; } });
    FACETS.forEach(function (F) {
      st.f[F.k].forEach(function (v) {
        var op = F.list.filter(function (x) { return x.v === v; })[0];
        if (op) a.push({ l: (F.k === 'p' || F.k === 'm' || F.k === 'dr' ? '' : F.label + ': ') + op.l, rm: function () { st.f[F.k] = st.f[F.k].filter(function (x) { return x !== v; }); } });
      });
    });
    return a;
  }
  var tagFns = [];
  function drawActive() {
    if (!active) return;
    var a = activeList(); tagFns = a.map(function (x) { return x.rm; });
    active.hidden = !a.length;
    active.innerHTML = a.length ? '<ul class="ssc-active__list">' + a.map(function (x, i) {
      return '<li><button type="button" class="ssc-tag" data-ssc-tag="' + i + '" aria-label="Remove filter: ' + esc(x.l) + '">' + esc(x.l) + '<span aria-hidden="true">×</span></button></li>';
    }).join('') + '<li><button type="button" class="ssc-tag ssc-tag--all" data-ssc-clearall>Clear all</button></li></ul>' : '';
  }

  var visCount = 0;
  function render() {
    var b = base();
    var vis = b.filter(function (it) { return facetOk(it); }).sort(sorter);
    visCount = vis.length;
    FACETS.forEach(function (F) {
      var pool = b.filter(function (it) { return facetOk(it, F.k); });
      F.list.forEach(function (op) {
        var inp = fBox && fBox.querySelector('input[data-f="' + F.k + '"][value="' + op.v + '"]');
        if (!inp) return;
        var n = pool.filter(op.t).length;
        inp.checked = st.f[F.k].indexOf(op.v) > -1;
        inp.parentNode.querySelector('[data-fn]').textContent = n;
        inp.disabled = n === 0 && !inp.checked;
        inp.parentNode.classList.toggle('is-off', inp.disabled);
      });
    });
    ranges.forEach(function (R) {
      var n = items.filter(function (it) { return it.r === R; }).length;
      R.btn.querySelector('[data-n]').textContent = n;
      R.btn.parentNode.hidden = n === 0;
      R.btn.setAttribute('aria-pressed', st.range === R ? 'true' : 'false');
    });
    if (typesSel) typesSel.textContent = st.range ? st.range.label : 'All types';
    var shownSet = {};
    vis.slice(0, st.shown).forEach(function (it) { shownSet[it.i] = 1; });
    vis.forEach(function (it) { grid.appendChild(it.el); });
    items.forEach(function (it) { if (vis.indexOf(it) < 0) grid.appendChild(it.el); it.el.hidden = !shownSet[it.i]; });
    var shownN = Math.min(st.shown, vis.length);
    if (showing) showing.textContent = vis.length ? 'Showing ' + shownN + ' of ' + vis.length + ' product' + (vis.length === 1 ? '' : 's') : '0 products';
    if (empty) empty.hidden = vis.length > 0;
    if (more) {
      var left = vis.length - shownN;
      more.hidden = left <= 0;
      if (moreBtn) moreBtn.textContent = 'Show ' + Math.min(PAGE, left) + ' more';
      if (prog) prog.style.width = (vis.length ? Math.round(shownN / vis.length * 100) : 0) + '%';
    }
    var nf = activeList().length;
    if (fcount) fcount.textContent = nf ? ' (' + nf + ')' : '';
    if (reset) reset.hidden = !nf;
    if (doneBtn) doneBtn.textContent = vis.length ? 'Show ' + vis.length + ' product' + (vis.length === 1 ? '' : 's') : 'No products — change filters';
    drawActive();
    drawFinder(b);
  }

  /* ---------- URL state (filters, type, sort) so Back/Forward and reload behave ---------- */
  function toQuery() {
    var q = new URLSearchParams(location.search);
    ['type', 'bund', 'n', 'sort'].concat(FACETS.map(function (F) { return F.k; })).forEach(function (k) { q.delete(k); });
    if (st.range) q.set('type', st.range.id);
    if (st.kind) { q.set('bund', st.kind); if (st.kind !== 'handling') q.set('n', st.n); }
    FACETS.forEach(function (F) { if (st.f[F.k].length) q.set(F.k, st.f[F.k].join(',')); });
    if (st.sort !== 'featured') q.set('sort', st.sort);
    var s = q.toString();
    return location.pathname + (s ? '?' + s : '') + location.hash;
  }
  function fromQuery() {
    var q = new URLSearchParams(location.search);
    st.f = emptyF();
    st.range = ranges.filter(function (R) { return R.id === q.get('type'); })[0] || null;
    var k = q.get('bund');
    st.kind = (k && (DEF[k] || k === 'handling') && finder) ? k : null;
    st.n = st.kind && st.kind !== 'handling' ? (parseInt(q.get('n'), 10) || DEF[st.kind]) : 0;
    FACETS.forEach(function (F) {
      var v = q.get(F.k);
      if (v) st.f[F.k] = v.split(',').filter(function (x) { return F.list.some(function (op) { return op.v === x; }); });
    });
    var s = q.get('sort');
    st.sort = (s && sortSel && sortSel.querySelector('option[value="' + s + '"]')) ? s : 'featured';
    if (sortSel) sortSel.value = st.sort;
    st.shown = PAGE;
  }
  function commit() {
    st.shown = PAGE;
    render();
    try { var u = toQuery(); if (u !== location.pathname + location.search + location.hash) history.pushState({ ssc: 1 }, '', u); } catch (e) {}
  }
  window.addEventListener('popstate', function () { fromQuery(); render(); });

  /* ---------- finder UI ---------- */
  function drawFinder(b) {
    if (!finder) return;
    var pills = finder.querySelectorAll('[data-ssc-kind]');
    Array.prototype.forEach.call(pills, function (p) {
      var k = p.getAttribute('data-ssc-kind');
      p.setAttribute('aria-pressed', k === st.kind ? 'true' : 'false');
    });
    var qty = finder.querySelector('[data-ssc-qty]'), counts = finder.querySelector('[data-ssc-counts]');
    var idle = finder.querySelector('[data-ssc-idle]'), res = finder.querySelector('[data-ssc-res]');
    var miss = finder.querySelector('[data-ssc-miss]'), clear = finder.querySelector('[data-ssc-clear]');
    var measured = st.kind && st.kind !== 'handling';
    qty.hidden = !measured;
    idle.hidden = measured;
    res.hidden = !measured;
    clear.hidden = !st.kind;
    miss.hidden = true;
    if (!measured) return;
    finder.querySelector('[data-ssc-qlabel]').textContent = QLABEL[st.kind];
    counts.innerHTML = COUNTS[st.kind].map(function (n) {
      return '<button type="button" class="ssc-pill ssc-pill--n" aria-pressed="' + (n === st.n) + '" data-ssc-n="' + n + '">' + n + '</button>';
    }).join('');
    var need = req();
    finder.querySelector('[data-ssc-req]').textContent = L(need);
    var n = b.length, sum = finder.querySelector('[data-ssc-sum]');
    if (n) {
      sum.textContent = 'minimum sump for ' + unit(st.kind, st.n) + ' — ' + n + ' product' + (n === 1 ? ' passes' : 's pass') + ', shown below.';
    } else {
      sum.innerHTML = 'minimum sump for ' + esc(unit(st.kind, st.n)) + ' — no single product in this range holds that many with a big enough sump. <a href="/pages/contact">Ask us</a> about splitting the load or a bunded store.';
    }
    if (st.kind !== 'can') {
      var near = items.filter(function (it) { return !st.range && it.o.hk === st.kind && it.o.hn >= st.n && it.o.s != null && it.o.s < need; })
        .sort(function (a, c) { return c.o.s - a.o.s; });
      if (near.length) {
        var f = near[0];
        miss.textContent = 'Hidden: ' + f.t + ' (' + L(f.o.s) + ' sump) — it holds ' + unit(st.kind, f.o.hn) + ', but the sump is under the ' + L(need) + ' you need' + (near.length > 1 ? '. ' + (near.length - 1) + ' more hidden for the same reason.' : '.');
        miss.hidden = false;
      }
    } else if (n) {
      miss.textContent = 'Check each tray\'s size on the product page to make sure your containers fit.';
      miss.hidden = false;
    }
  }

  /* ---------- events ---------- */
  var typesBox = root.querySelector('[data-ssc-types]'), typesTog = root.querySelector('[data-ssc-types-tog]');
  var mqS = window.matchMedia ? matchMedia('(max-width: 749px)') : null;
  function setTypes(open) {
    if (!typesBox || !typesTog) return;
    typesTog.setAttribute('aria-expanded', open ? 'true' : 'false');
    typesBox.classList.toggle('is-collapsed', !open);
  }
  if (typesBox && typesTog) {
    setTypes(!(mqS && mqS.matches));
    if (mqS) { var onMq = function () { setTypes(!mqS.matches); }; if (mqS.addEventListener) mqS.addEventListener('change', onMq); else if (mqS.addListener) mqS.addListener(onMq); }
  }

  root.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-ssc-types-tog]'))) { setTypes(t.getAttribute('aria-expanded') !== 'true'); return; }
    if ((t = e.target.closest('[data-ssc-range]'))) {
      var R = ranges.filter(function (x) { return x.btn === t; })[0];
      st.range = st.range === R ? null : R;
      if (st.kind) st.kind = null;
      commit(); return;
    }
    if ((t = e.target.closest('[data-ssc-kind]'))) {
      var k = t.getAttribute('data-ssc-kind');
      if (st.kind === k) { st.kind = null; st.range = null; }
      else if (k === 'handling') {
        var lab = (t.getAttribute('data-range-label') || '').toLowerCase();
        st.kind = 'handling'; st.range = ranges.filter(function (x) { return x.label.toLowerCase() === lab; })[0] || null;
      } else { st.kind = k; st.n = DEF[k]; st.range = null; }
      commit(); return;
    }
    if ((t = e.target.closest('[data-ssc-n]'))) { st.n = parseInt(t.getAttribute('data-ssc-n'), 10); commit(); return; }
    if (e.target.closest('[data-ssc-clear]')) { st.kind = null; st.range = null; commit(); return; }
    if (e.target.closest('[data-ssc-more-btn]')) {
      /* reveal the next batch in place; move focus to the first new product so keyboard users continue where the list grew */
      var before = st.shown; st.shown += PAGE; render();
      var nc = grid.children[before], na = nc && !nc.hidden && nc.querySelector('[data-ssc-title]');
      if (na) na.focus({ preventScroll: true });
      return;
    }
    if ((t = e.target.closest('[data-ssc-tag]'))) {
      var fn = tagFns[parseInt(t.getAttribute('data-ssc-tag'), 10)];
      if (fn) fn();
      commit();
      var next = active && active.querySelector('[data-ssc-tag]');
      if (next) next.focus(); else if (showing) { showing.setAttribute('tabindex', '-1'); showing.focus(); }
      return;
    }
    if (e.target.closest('[data-ssc-reset]') || e.target.closest('[data-ssc-reset-all]') || e.target.closest('[data-ssc-clearall]')) {
      st.f = emptyF(); st.range = null; st.kind = null;
      commit();
      if (e.target.closest('[data-ssc-clearall]') && showing) { showing.setAttribute('tabindex', '-1'); showing.focus(); }
      return;
    }
    if (e.target.closest('[data-ssc-side-open]')) { openSide(); return; }
    if (e.target.closest('[data-ssc-side-close]')) { closeSide(); return; }
    if (e.target.closest('[data-ssc-copen]')) { openCompare(); return; }
    if (e.target.closest('[data-ssc-cclear]')) { cmp = []; syncCompare(); return; }
    if (e.target.closest('[data-ssc-cclose]')) { dlg.close(); return; }
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-f]')) {
      var arr = st.f[t.getAttribute('data-f')], v = t.value, ix = arr.indexOf(v);
      if (t.checked && ix < 0) arr.push(v); else if (!t.checked && ix > -1) arr.splice(ix, 1);
      commit(); return;
    }
    if (t.matches('[data-ssc-sort]')) { st.sort = t.value; commit(); return; }
    if (t.matches('[data-ssc-cmp]')) {
      var i = parseInt(t.value, 10);
      if (t.checked) { if (cmp.length < 3 && cmp.indexOf(i) < 0) cmp.push(i); else t.checked = false; }
      else cmp = cmp.filter(function (x) { return x !== i; });
      syncCompare();
    }
  });

  /* ---------- mobile filter drawer (modal below 990px) ---------- */
  var side = root.querySelector('[data-ssc-side]'), sideOpen = root.querySelector('[data-ssc-side-open]');
  function sideFocusables() { return Array.prototype.slice.call(side.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], select')).filter(function (x) { return x.offsetParent !== null; }); }
  function openSide() {
    side.classList.add('is-open'); document.documentElement.classList.add('ssc-lock');
    side.setAttribute('role', 'dialog'); side.setAttribute('aria-modal', 'true'); side.setAttribute('aria-labelledby', 'ssc-side-h');
    if (sideOpen) sideOpen.setAttribute('aria-expanded', 'true');
    var x = side.querySelector('.ssc-side__x'); if (x) x.focus();
  }
  function closeSide() {
    if (!side.classList.contains('is-open')) return;
    side.classList.remove('is-open'); document.documentElement.classList.remove('ssc-lock');
    side.removeAttribute('role'); side.removeAttribute('aria-modal'); side.removeAttribute('aria-labelledby');
    if (sideOpen) { sideOpen.setAttribute('aria-expanded', 'false'); sideOpen.focus(); }
  }
  document.addEventListener('keydown', function (e) {
    if (!side || !side.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeSide(); return; }
    if (e.key !== 'Tab') return;
    var f = sideFocusables(); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === a || !side.contains(document.activeElement))) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && (document.activeElement === z || !side.contains(document.activeElement))) { e.preventDefault(); a.focus(); }
  });
  var mqD = window.matchMedia ? matchMedia('(min-width: 990px)') : null;
  if (mqD) { var onD = function () { if (mqD.matches) closeSide(); }; if (mqD.addEventListener) mqD.addEventListener('change', onD); else if (mqD.addListener) mqD.addListener(onD); }

  /* ---------- add to basket ---------- */
  root.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-ssc-add]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    var btn = f.querySelector('button'), label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓'; btn.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        setTimeout(function () { btn.textContent = label; btn.disabled = false; btn.classList.remove('is-done'); }, 2500);
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; HTMLFormElement.prototype.submit.call(f); });
  });

  /* ---------- compare ---------- */
  var cmp = [], cbar = root.querySelector('[data-ssc-cbar]'), dlg = root.querySelector('[data-ssc-cdlg]');
  function syncCompare() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-ssc-cmp]'), function (c) {
      var i = parseInt(c.value, 10);
      c.checked = cmp.indexOf(i) > -1;
      c.disabled = !c.checked && cmp.length >= 3;
      c.closest('.ssc-cmp').classList.toggle('is-off', c.disabled);
    });
    cbar.hidden = cmp.length === 0;
    root.querySelector('[data-ssc-cn]').textContent = cmp.length;
    var names = root.querySelector('[data-ssc-cnames]');
    if (names) names.textContent = cmp.map(function (i) { return items[i].short; }).join(', ');
    var go = root.querySelector('[data-ssc-copen]');
    go.disabled = cmp.length < 2;
    go.textContent = cmp.length < 2 ? 'Select 2 or 3 to compare' : 'Compare ' + cmp.length;
    document.documentElement.classList.toggle('ssc-has-cbar', cmp.length > 0);
  }
  function openCompare() {
    var list = cmp.map(function (i) { return items[i]; });
    var rows = [
      ['Price', function (it) { return (it.d.pv ? 'From ' : '') + money(it.p) + ' incl. VAT'; }],
      ['External size', function (it) { return it.o.dims || (it.o.dim ? it.o.dim + ' (order as in title)' : ''); }],
      ['Storage capacity', function (it) { return it.o.cap != null ? L(it.o.cap) : ''; }],
      ['Sump capacity', function (it) { return it.o.s != null ? L(it.o.s) : ''; }],
      ['Holds', function (it) { return it.o.hn && it.o.hk ? unit(it.o.hk, it.o.hn) : ''; }],
      ['Doors', function (it) { return it.o.doors != null ? String(it.o.doors) : ''; }],
      ['Shelves', function (it) { return it.o.shelves != null ? String(it.o.shelves) : ''; }],
      ['Product weight', function (it) { return it.o.kg != null ? it.o.kg.toLocaleString('en-GB') + ' kg' : ''; }],
      ['Load rating', function (it) { return it.o.load != null ? it.o.load.toLocaleString('en-GB') + ' kg' : ''; }],
      ['Absorbs', function (it) { return it.o.ab != null ? L(it.o.ab) : ''; }],
      ['Material', function (it) { return it.o.m || ''; }],
      ['Colour', function (it) { return it.d.oc > 1 ? it.d.oc + ' colours' : (it.o.c || ''); }],
      ['Code', function (it) { return it.d.sku || ''; }]
    ].filter(function (r) { return list.some(function (it) { return r[1](it); }); });
    var h = '<table class="ssc-ct"><caption class="ssh-sr">Comparison of ' + list.length + ' products</caption><thead><tr><th scope="col"><span class="ssh-sr">Specification</span></th>' + list.map(function (it) {
      return '<th scope="col">' + (it.d.img ? '<img src="' + esc(it.d.img) + '" alt="" width="80" height="80">' : '') + '<a href="' + esc(it.d.u) + '">' + esc(it.short) + '</a></th>';
    }).join('') + '</tr></thead><tbody>' + rows.map(function (r) {
      return '<tr><th scope="row">' + r[0] + '</th>' + list.map(function (it) { return '<td>' + esc(r[1](it) || 'Not listed') + '</td>'; }).join('') + '</tr>';
    }).join('') + '</tbody></table><p class="ssc-ct__note">Sizes are shown in the order listed on each product page (L = length, W = width, H = height). Storage capacity and sump capacity are different measures.</p>';
    root.querySelector('[data-ssc-ctable]').innerHTML = h;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    var x = dlg.querySelector('[data-ssc-cclose]'); if (x) x.focus();
  }
  if (dlg) {
    dlg.addEventListener('click', function (e) {
      if (e.target !== dlg) return;
      var r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
    });
    dlg.addEventListener('close', function () { var go = root.querySelector('[data-ssc-copen]'); if (go) go.focus(); });
  }

  fromQuery();
  root.classList.add('is-ready');
  render();
  syncCompare();
})();